import { SortResult, SortedDocs } from './types';
import { DocType, PilotDoc } from '../../../types';
import { sortDocsByDate } from '../../../libs/sortDocsByDate';

export function filterAndSortW9(docs: PilotDoc[]): SortResult {
  const processedW9: SortedDocs = {
    good: [],
    needAttention: [],
  };

  // if there is no document of type, return missedDocTypes and stop
  if (docs.length === 0) {
    return { ...processedW9, missedDocTypes: DocType.TAX_FORM_W9 };
  }

  // Here there could be only expired documents. Sort them and get one with the latest end date
  const sortedByStartDate = sortDocsByDate(docs, false);
  const theLatestDoc = sortedByStartDate[0];

  processedW9.good.push(theLatestDoc);

  return processedW9;
}
